// src/stockx/flat/TooltipIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx } from "react/jsx-runtime";
var TooltipIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsx(Icon, { viewBox: "0 0 50 50", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M25 6C14.5 6 6 14.5 6 25C6 35.5 14.5 44 25 44C35.5 44 44 35.5 44 25C44 14.5 35.5 6 25 6ZM26.4 36.2H22V31.7H26.4V36.2ZM29 25C27 26.1 26.2 26.8 26.2 29V29.2H22.1V28.9C22.1 25.9 23.2 24.6 25.3 23.4C27.2 22.3 28.5 21.3 28.5 19.7C28.5 18.1 26.9 17.1 25.3 17.1C23.1 17.1 21.4 18.3 21.3 21.2H17.2C17.2 16.8 20.7 14 25.3 14C29 14 32.6 15.7 32.6 19.5C32.7 22.3 30.7 24 29 25Z",
    fill: colorized ? "#A1A5A4" : "currentColor"
  }
) });
var TooltipIcon_default = TooltipIcon;

export {
  TooltipIcon_default
};
